import { render } from "./customer-dispatch-modal.vue?vue&type=template&id=32fed655"
import script from "./customer-dispatch-modal.vue?vue&type=script&lang=js"
export * from "./customer-dispatch-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__